import { SendCodeRequestEnum, SendCodeResponseEnum } from "@b2bportal/auth-api";
import { sendCode } from "../../api";
import type { AuthMachineContext } from "../context";
import { getEmail } from "../selectors";

export const sendCodeToEmailService = (context: AuthMachineContext, _event) =>
  new Promise((resolve, reject) => {
    const email = getEmail({ context }) as string;

    sendCode({
      email: email,
      SendCodeRequest: SendCodeRequestEnum.SendCodeEmail,
    })
      .then((res) => {
        if (res.SendCodeResponse === SendCodeResponseEnum.SendCodeFailed) {
          reject("SendCodeResponseEnum.SendCodeFailed");
        } else {
          resolve(res);
        }
      })
      .catch((error) => reject(error));
  });
